import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["showClose", "value"];
import "core-js/modules/es6.object.assign.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Created by chief on 17/4/6.
 */
import MonthCalendar from "./rc-calendar/MonthCalendar";
import { KeyCode } from '../../wui-core/src';
import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Picker from "./rc-calendar/Picker";
import Icon from "../../wui-icon/src";
import InputGroup from '../../wui-input-group/src';
import Input from '../../wui-input/src';
import classnames from 'classnames'; // import zhCN from "./locale/zh_CN";

import omit from 'omit.js';
import moment from "moment";
import { formatDate } from './rc-calendar/util';
import { prefix } from "../../wui-core/src/index.js";
import { getLangInfo } from "./lang-utils";

var MonthPicker = /*#__PURE__*/function (_Component) {
  _inherits(MonthPicker, _Component);

  var _super = _createSuper(MonthPicker);

  function MonthPicker(_props, context) {
    var _this;

    _classCallCheck(this, MonthPicker);

    _this = _super.call(this, _props, context);

    _defineProperty(_assertThisInitialized(_this), "handleCalendarChange", function (value) {
      _this.setState({
        value: value && Object.assign(value, {
          _type: 'month'
        }) || value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onClear = _this$props.onClear,
          onSelect = _this$props.onSelect,
          format = _this$props.format;

      _this.setState({
        value: value && Object.assign(value, {
          _type: 'month'
        }) || value
      });

      onChange && onChange(value, value ? formatDate(value, format) : '');
    });

    _defineProperty(_assertThisInitialized(_this), "inputFocus", function () {
      var self = _assertThisInitialized(_this);

      var format = self.props.format;
      var input = document.querySelector(".".concat(prefix, "-date-calendar-input"));

      if (input) {
        if (input.value) {
          input.select();
        } else {
          input.focus();
        }

        input.onkeydown = function (e) {
          if (e.keyCode == KeyCode.DELETE) {
            input.value = '';
            self.props.onChange && self.props.onChange('', '');
          } else if (e.keyCode == KeyCode.ESC) {
            self.setState({
              open: false
            });
            var v = self.state.value;
            self.props.onOpenChange && self.props.onOpenChange(false, v, v && formatDate(v, self.props.format) || '');
            ReactDOM.findDOMNode(self.outInput).focus(); // 按esc时候焦点回到input输入框
          } else if (e.keyCode == KeyCode.ENTER) {
            var parsed = moment(input.value, format, true);

            if (parsed.isValid && parsed.isValid()) {
              self.setState({
                open: false
              });
              var _v = self.state.value;
              self.props.onOpenChange && self.props.onOpenChange(false, _v, _v && formatDate(_v, format) || '');
              self.outInput && ReactDOM.findDOMNode(self.outInput).focus();
            }
          }
        };
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onOpenChange", function (open) {
      var props = _this.props;

      var self = _assertThisInitialized(_this);

      _this.setState({
        open: open
      }, function () {
        if (open) {
          setTimeout(function () {
            self.inputFocus();
          }, 0);
        }
      });

      var value = self.state.value;
      props.onOpenChange && props.onOpenChange(open, value, value && formatDate(value, self.props.format) || '');

      if (open) {
        setTimeout(function () {
          self.inputFocus();
        }, 200);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onTypeChange", function (type) {
      _this.setState({
        type: type
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (e) {
      _this.setState({
        showClose: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (e) {
      _this.setState({
        showClose: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clear", function (e) {
      e.stopPropagation();

      _this.setState({
        value: ''
      });

      _this.props.onChange && _this.props.onChange('', '');
    });

    var langInfo = getLangInfo(_props.locale); //获取语言包信息

    _this.state = {
      langInfo: langInfo,
      type: "month",
      value: moment(_props.value) || moment(_props.defaultValue),
      open: false,
      showClose: false
    };
    return _this;
  }

  _createClass(MonthPicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var value = this.props.value || this.props.defaultValue;
      var format = this.props.format;

      if (value) {
        if (typeof value == 'string') {
          if (moment(value, format).isValid()) {
            value = moment(value, format);
          } else {
            console.error('value is not in the correct format');
            value = '';
          }
        } else if (value.format && value.isValid && value.isValid()) {
          value = value;
        } else {
          console.error('value is not in the correct format');
          value = '';
        }
      }

      this.setState({
        value: value
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('value' in nextProps) {
        var value = nextProps.value;

        if (value) {
          if (value.format && value.isValid && value.isValid()) {} else {
            value = moment(value, this.props.format);
          }
        } else {
          value = '';
        }

        this.setState({
          value: value
        });
      }

      if ("locale" in nextProps) {
        var langInfo = getLangInfo(nextProps.locale); //获取语言包信息

        this.setState({
          langInfo: langInfo
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var state = this.state;
      var props = this.props;

      var showClose = props.showClose,
          value = props.value,
          others = _objectWithoutProperties(props, _excluded);

      var monthCalendar = /*#__PURE__*/React.createElement(MonthCalendar, _extends({}, props, {
        locale: state.langInfo.langMap,
        value: state.value,
        onChange: this.handleCalendarChange
      }));
      var classes = classnames(props.className, "".concat(prefix, "-datepicker-container"));
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classes
      }, omit(others, ['inputReadOnly', 'closeIcon', 'renderIcon', 'format', 'showDateInput', 'showMonthInput', 'locale', 'placeholder', 'onClear', 'renderFooter', 'renderError', 'disabledDate', 'disabledTime', 'className', 'allowClear', 'renderExtraFooter', 'autoTriggerChange', 'disabledYear', 'showTime', 'validatorFunc', 'inputTabKeyOpen', 'destroyOnClose', 'disabledYear'])), /*#__PURE__*/React.createElement(Picker, _extends({}, props, {
        onOpenChange: this.onOpenChange,
        animation: 'animation' in props ? props.animation : "slide-up",
        calendar: monthCalendar,
        open: this.state.open,
        value: state.value,
        onChange: this.onChange,
        dropdownClassName: props.dropdownClassName,
        selectedValue: state.value,
        renderError: props.renderError
      }), function (_ref) {
        var value = _ref.value;
        var propsValStr;

        if (value && value.format && value.isValid && value.isValid()) {
          value = typeof value != 'string' ? formatDate(value, props.format) : value;
          propsValStr = typeof props.value != 'string' ? formatDate(props.value, props.format) : props.value; // 为了避免在输入框内输入月份的过程中显示invalid date

          if (value != propsValStr && propsValStr.length != 0) {
            value = props.value;
          }
        } else {
          value = typeof props.value != 'string' ? formatDate(props.value, props.format) : props.value;
          {
            /* value = props.value; */
          }
        }

        return /*#__PURE__*/React.createElement(InputGroup, {
          simple: true,
          className: "".concat(prefix, "-datepicker-input-group"),
          onMouseEnter: _this2.onMouseEnter,
          onMouseLeave: _this2.onMouseLeave
        }, /*#__PURE__*/React.createElement(Input, {
          ref: function ref(_ref2) {
            return _this2.outInput = _ref2;
          },
          placeholder: _this2.props.placeholder,
          className: _this2.props.className,
          value: value,
          disabled: props.disabled
        }), showClose && _this2.state.value && _this2.state.showClose && !props.disabled ? /*#__PURE__*/React.createElement(Input.Button, {
          shape: "border",
          onClick: _this2.clear
        }, props.closeIcon()) : /*#__PURE__*/React.createElement(Input.Button, {
          shape: "border"
        }, props.renderIcon()));
      }));
    }
  }]);

  return MonthPicker;
}(Component);

MonthPicker.defaultProps = {
  closeIcon: function closeIcon() {
    return /*#__PURE__*/React.createElement(Icon, {
      type: "uf-close-c"
    });
  },
  renderIcon: function renderIcon() {
    return /*#__PURE__*/React.createElement(Icon, {
      type: "uf-calendar"
    });
  },
  format: 'YYYY-MM',
  renderError: function renderError() {},
  showDateInput: true,
  showMonthInput: true,
  locale: 'zh-cn',
  showClose: true,
  autoTriggerChange: true,
  inputReadOnly: false,
  validatorFunc: function validatorFunc() {
    return true;
  }
};
export default MonthPicker;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/MonthPicker.js